<template>
  <div>
    <transition name="fast-fade">
      <div v-if="source" class="background">
        <transition name="fade" mode="in-out">
          <div class="background__wrapper" :key="activeSource + sourceType">
            <img
              v-if="sourceType === 'image'"
              :src="activeSource"
            >
            <video
              v-if="sourceType === 'video'"
              :src="activeSource"
              ref="video"
              autoplay
              playsinline
              disablePictureInPicture
              :loop="true"
              @ended="handleVideoEnd"
            />
            <div
              v-if="sourceType === 'video' && ( backgroundVideoSettings ? backgroundVideoSettings.showControls : true)"
              class="background__control"
            >
              <div class="control control--mute touch" @click="toggleMute">
                <fa v-if="isVideoMuted" :icon="['fal', 'volume-mute']"/>
                <fa v-if="!isVideoMuted" :icon="['fal', 'volume']"/>
              </div>
              <div class="control control--playback touch" @click="togglePlayback">
                <fa v-if="isVideoPlaying" :icon="['fal', 'pause']"/>
                <fa v-if="!isVideoPlaying" :icon="['fal', 'play']"/>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import { bus } from '../main'
import _ from 'lodash'

export default {
  props: ['source'],

  data () {
    return {
      activeSource: '',
      isVideoPlaying: true,
      isVideoMuted: false,
    }
  },

  computed: {
    sourceType () {
      if (this.activeSource) {
        const ext = this.activeSource.split('.').pop().toLowerCase()
        if (ext === 'mov' || ext === 'mp4') {
          return 'video'
        }

        if (ext === 'jpeg' || ext === 'jpg' || ext === 'png' || ext === 'gif') {
          return 'image'
        }

        return 'unsupported'
      }
      return ''
    },

    backgroundVideoSettings () {
      if (this.$store.getters.activePage) {
        return this.$store.getters.activePage.backgroundVideoSettings
      } else {
        return {}
      }
    }
  },

  watch: {
    $route () {
      this.$store.commit('SET_ACTIVE_BACKGROUND_OVERRIDE', '')
    },

    source: {
      handler (newSource, oldSource) {
        if (newSource && this.sourceType === 'video') {
          const video = this.$refs.video
          if (video) {
            this.isVideoMuted = video.muted
          }
        }

        if (!_.isEqual(oldSource, newSource)) {
          if (oldSource !== '') {
            this.activeSource = ''
          }

          if (newSource !== '') {
            this.$store.commit('addAnimationToQueue', 'Background')
            if (this.backgroundVideoSettings.delayTags) {
              this.$store.commit('addAnimationToQueue', 'BackgroundVideo')
            }
          }
        }
      },
      immediate: true
    },
  },

  mounted () {
    bus.$on('animateBackground', () => {
      this.activeSource = this.source
      bus.$emit('finishedAnimation', 'Background')
    })
  },

  methods: {
    handleVideoEnd () {
      if (this.backgroundVideoSettings.delayTags) {
        bus.$emit('finishedAnimation', 'Background')
      }
    },

    togglePlayback () {
      const video = this.$refs.video

      if (video && video.paused) {
        this.isVideoPlaying = true
        video.play()
      } else { 
        this.isVideoPlaying = false
        video.pause()
      }
    },

    toggleMute () {
      const video = this.$refs.video

      if (video) {
        this.isVideoMuted = !video.muted
        video.muted = !video.muted
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.background {
  height: 98rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 159.5rem;
  z-index: 0;

  .layout-switched & {
    top: 10rem;
  }

  &__wrapper {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

  &__control {
    bottom: 5rem;
    display: flex;
    font-size: 2rem;
    padding: 0 1rem;
    position: absolute;
    right: 0;

    .control {
      margin-left: 1rem;
    }
  }

  img,
  video {
    height: 100%;
    object-fit: cover;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}
</style>